module.exports = __webpack_public_path__ + "static/media/heroku2.613443c9.jpg";